<script setup>
import {reactive, computed, onMounted, ref} from 'vue';
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {activeComponentStore} from "@/Stores/ActiveComponentStore";
import {Permissions} from "@/Utils/Permissions";
import {FormValidation} from "@/Utils/FormValidation";
import {ToastUtil} from "@/Utils/ToastUtil";

  const compName = 'ClientCardComponent';

  const props = defineProps({
    contextSchemaA: String,
    contextIdA: String
  });

  const form = ref(null);
  
  const data = reactive({
    hovered: false,
    hovered2: false,
    loadingClient: false,
    contextSchema: null,
    search: '',
    changingClient: false,
    claims: false,
    selectedClient: null,
    clientNames: [],
    clientId: null,
    loaded: false,
    name: '',
    clientmessage: '',
    phone: '',
    streetaddress: null,
    city: null,
    state: null,
    zip: null,
    invoicenet_term: null,
    addContact: false,
    selected: [],
    phoneMessage: false,
    dialog: false,
    phoneMessageDetails: '',
    emailMessage: false,
    emailMessageDetails: '',
    editSelected: false,
    editSingle: false,
    contactSelected: false,
    role: ['Representative', 'Attorney'],
    loading: false,
    openForm: false,
    valid: true,
    newItem: {
      role: '',
      insuredname: '',
      streetaddress: '',
      city: '',
      state: '',
      zip: '',
      homephone: '',
      email: '',
      longitude: '',
      latitude: '',
    },
    editedItem: {
      role: '',
      insuredname: '',
      streetaddress: '',
      city: '',
      state: '',
      zip: '',
      homephone: '',
      email: '',
      longitude: '',
      latitude: '',
    },
    resetContactItem: {
      role: '',
      insuredname: '',
      streetaddress: '',
      city: '',
      state: '',
      zip: '',
      homephone: '',
      email: '',
      longitude: '',
      latitude: ''
    },
    items: [],
    client: [],
    clients: [],
    files: [],
    searchedContact: null,
    clientSelected: true,
  });
  
  const filteredItems = computed(()=>{
    return data.clientNames.filter((item) => {
      return item.toLowerCase().includes(data.search.toLowerCase())
    })
  })

  const acceptNumber = () => {
    let x = data.newItem.homephone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    data.newItem.homephone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
  }
  
  const removePerson = async(pid, rid) => {
    data.dialog = false;
    data.loading = true
    await ApiWrapper.post('claims', 'remove-client-contact',{
          pid: pid,
          rid: rid,
          claimId: props.contextIdA
        })
        .then((response) => {
          getClientContactData()
          data.contactSelected = false
          activeComponentStore.notifyComponents(['adjusters'],compName);

          ToastUtil.successMsg('Removed client contact');
        })
        .catch((err) => {
          ToastUtil.error(err);
          data.loading = false;
        })
  }
  
  const editSingleItem = () => {
    data.openForm = true
    data.editSingle = true
    data.editedItem = Object.assign({}, data.items[0])
    data.newItem = Object.assign({}, data.items[0])
  }
  
  const editSelectedItem = () => {
    data.openForm = true
    data.editSelected = true
    data.newItem = Object.assign({}, data.selected[0])
    data.editedItem = Object.assign({}, data.selected[0])
  }
  
  const saveMessage = async (type, personid) => {
    data.loading = true
    if (type === 'phone') {
      await ApiWrapper.post('relationship-management', 'create-interaction', {
            claimId: props.contextIdA,
            interaction: data.phoneMessageDetails,
            contactId: personid,
            type: 'clientcontacts',
          })
          .then((response) => {
            activeComponentStore.notifyComponents(['messages'],compName);
            data.phoneMessage = false
            data.phoneMessageDetails = ''
            getData()

            ToastUtil.successMsg('Created note');
          })
          .catch((e)=>{
            ToastUtil.error(e);
            data.loading = false;
          })
    } else if (type === 'email') {
      await ApiWrapper.post('relationship-management', 'create-interaction', {
            claimId: props.contextIdA,
            interaction: data.emailMessageDetails,
            contactId: personid,
            type: 'clientcontacts',
          })
          .then((response) => {
            activeComponentStore.notifyComponents(['messages'],compName);
            data.emailMessage = false
            data.emailMessageDetails = ''
            getData()
            ToastUtil.successMsg('Created note');
          })
          .catch((e)=>{
            ToastUtil.error(e);
            data.loading = false;
          })
    }
  }
  
  const chooseContact = (item) => {
    data.selected = []
    data.selected.push(item)
    data.editedItem = JSON.parse(JSON.stringify(item))
  }
  
  const cancel = () => {
    if (data.editSingle) {
      data.items[0] = Object.assign({}, data.editedItem)
      data.editedItem = JSON.parse(JSON.stringify(data.resetContactItem))
    }
    if (data.editSelected) {
      data.selected[0] = Object.assign({}, data.editedItem)
      data.editedItem = JSON.parse(JSON.stringify(data.resetContactItem))
    }
    data.openForm = false
  }
  
  const selectContact = async() => {
    if (form.value.validate()) {
      data.loading = true;
      await ApiWrapper.post('claims', 'link-client-contact', {
            claimId: props.contextIdA,
            clientContactId: data.searchedContact,
          })
          .then((response) => {
            getClientContactData()
          })
          .catch((e)=>{
            ToastUtil.error(e);
            data.loading = false;
          })
    }
  }
  
  const back = () => {
    data.selected.splice(0, 1)
    data.contactSelected = false
  }

  const windowOpen = async (file) => {
    if(Permissions.checkPermissions(['files.download'])) {
      await ApiWrapper.post("client-files", "download-file", {key: file.key})
          .then((response) => {
            window.open(response.url, "_blank");
          })
          .catch((err) => {
            ToastUtil.error(err);
          });
    }
  }

  const getData = async() => {
    await getAllClients();
    // let contextId = new URLSearchParams(window.location.search).get(
    //     'contextIdA'
    // )
    let contextId = props.contextIdA;
    // let contextSchema = new URLSearchParams(window.location.search).get(
    //     'contextSchemaA'
    // )
    let contextSchema = props.contextSchemaA;
    if (contextSchema === 'claims') {
      data.claims = true

      await ApiWrapper.get('client-card', 'client-card-claim','claimId=' + contextId)
          .then(async(response) => {
            if(response.client) {
              data.name = response.client.name
              data.clientmessage = response.client.clientmessage
              if (data.clientmessage === '' || data.clientmessage === null) {
                data.clientmessage = 'No Message Available'
              }
              data.phone = response.client.phone
              data.streetaddress = response.client.streetaddress
              data.city = response.client.city
              data.state = response.client.state
              data.zip = response.client.zip
              data.invoicenet_term = response.client.invoicenet_term
              data.loaded = true
              data.clientId = response.client?.id
              data.selectedClient = response.client.name
              data.changingClient = false
              data.loadingClient = false

              if (Permissions.checkPermissions(['files.list']) && data.clientId) {
                await ApiWrapper.post("client-files", "list-files", {clientId: data.clientId, test: 'hi', listAll: false})
                    .then((response) => {
                      data.files = response.files;
                    })
                    .catch((e) => {
                      ToastUtil.error(e);
                      data.loading = false;
                    })
              }

              await getClientContactData();
            }
          })
          .catch((e)=>{
            ToastUtil.error(e);
            data.loading = false;
          })
    } else {
      await ApiWrapper.get('client-card', 'client-card','clientId=' + contextId)
          .then((response) => {
            data.name = response.name
            data.phone = response.phone
            data.clientmessage = response.clientmessage
            if(data.clientmessage === '' || data.clientmessage === null){
              data.clientmessage = 'No Message Available'
            }
            data.streetaddress = response.streetaddress
            data.city = response.city
            data.zip = response.zip
            data.invoicenet_term = response.invoicenet_term
            data.state = response.state
            data.loaded = true
            data.clientId = response.id
            data.selectedClient = response.id
            data.changingClient = false
            data.loadingClient = false
            getClientContactData()
          })
          .catch((e)=>{
            ToastUtil.error(e);
            data.loading = false;
            data.loadingClient = false;
          })
    }
  }

  const getAllClients = async () => {
    await ApiWrapper.get('client-card', 'get-clients')
    .then((response) => {
      data.clientsClientCard = response.clients
      data.clientNames = response.clients.map(function (obj) {
        return obj.name
      })
    })
    .catch((e)=>{
      ToastUtil.error(e);
    })
  }

  const getClientContactData = async() => {
    data.loading = true
    // let contextId = new URLSearchParams(window.location.search).get(
    //     'contextIdA'
    // )
    await ApiWrapper.post('claims', 'get-client-contacts', { claimId: props.contextIdA })
        .then((response) => {
          data.clientSelected = true;

          data.items = response.data;
          data.items.sort(function(a, b) {
            let keyA = a.insuredname,
                keyB = b.insuredname;
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          });
          data.clients = response.names
          data.searchedContact = null
          data.dialog = false
        })
        .catch((e)=>{
          data.clientSelected = false
          ToastUtil.error(e);
        })
        .finally(()=>{
          data.loading = false
        })
}

  const create = async() => {
    if (form.value.validate()) {
      data.openForm = false
      if (data.editSingle || data.editSelected) {
        data.loading = true
        // let contextId = new URLSearchParams(window.location.search).get(
        //     'contextIdA'
        // )
        if(data.newItem.streetaddress !== '' && data.newItem.streetaddress !== null){
          let encodedSearch = encodeURI(
              data.newItem.streetaddress.replace('#', '') +
              `, ` +
              data.newItem.city +
              `, ` +
              data.newItem.state +
              ` ` +
              data.newItem.zip
          )
          await ApiWrapper.getRaw('https://api.mapbox.com/geocoding/v5/mapbox.places/' +
                encodedSearch +
                '.json?access_token=pk.eyJ1IjoiZW50cmVvcyIsImEiOiJja2RydG16MXEwZ3hvMnhuOXVlcHZhcWRvIn0.mlZA3MAQSFupaQbmFjA9QQ'
          )
          .then(async function (response) {
            if (response.features.length === 0) {
              ToastUtil.errorMsg('No location found for that address')
              await getData()
            } else {
              data.newItem.longitude =
                  response.features[0].center[0].toString()
              data.newItem.latitude =
                  response.features[0].center[1].toString()
              await ApiWrapper.post('claims', 'update-client-contact', {
                    newItem: data.newItem,
                  })
                  .then((response) => {
                    getData()
                    back()
                    ToastUtil.successMsg('Updated client contact');
                  })
                  .catch((e)=>{
                    ToastUtil.error(e);
                    data.loading = false;
                  })
            }
          })
          .catch((err) => {
            ToastUtil.error(err);
            data.loading = false;
          });
        }else{
          await ApiWrapper.post('claims', 'update-client-contact', {
                newItem: data.newItem,
              })
              .then((response) => {
                getData()
                back()
                ToastUtil.successMsg('Updated client contact');
              })
              .catch((e)=>{
                ToastUtil.error(e);
                data.loading = false;
              })
        }
        data.openForm = false
        data.editSingle = false
        data.editSelected = false
      }else{
        data.loading = true
        // let contextId = new URLSearchParams(window.location.search).get(
        //     'contextIdA'
        // )
        let encodedSearch = encodeURI(
            data.newItem.streetaddress.replace('#', '') +
            `, ` +
            data.newItem.city +
            `, ` +
            data.newItem.state +
            ` ` +
            data.newItem.zip
        )
        if(data.newItem.streetaddress !== ''){

          await ApiWrapper.getRaw(
                'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
                encodedSearch +
                '.json?access_token=pk.eyJ1IjoiZW50cmVvcyIsImEiOiJja2RydG16MXEwZ3hvMnhuOXVlcHZhcWRvIn0.mlZA3MAQSFupaQbmFjA9QQ'
          )
          .then(async function (response) {
            if (response.features.length === 0) {
              ToastUtil.errorMsg('No location found for that address')
              await getClientContactData()
            } else {
              data.newItem.longitude =
                  response.features[0].center[0].toString()
              data.newItem.latitude =
                  response.features[0].center[1].toString()
              await ApiWrapper.post('claims', 'create-client-contact', {
                    newItem: data.newItem,
                    claimId: props.contextIdA,
                  })
                  .then((response) => {
                    data.newItem = data.resetContactItem
                    data.openForm = false
                    getClientContactData()
                    back()
                    ToastUtil.successMsg('Created client contact');
                  })
                  .catch((e)=>{
                    ToastUtil.error(e);
                    data.loading = false;
                  })
            }
          })
          .catch((e)=>{
            ToastUtil.error(e);
            data.loading = false;
          })
        }else{
          await ApiWrapper.post('claims', 'create-client-contact', {
                newItem: data.newItem,
                claimId: props.contextIdA,
              })
              .then((response) => {
                data.newItem = data.resetContactItem
                data.openForm = false
                getClientContactData()
                back()
                ToastUtil.successMsg('Created client contact');
              })
              .catch((e)=>{
                ToastUtil.error(e);
                data.loading = false;
              })
        }
      }
    }
  }
  
  const formatPhoneNumber = (phoneNumberString) => {
    let cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3]
    }
    return null
  }
  
  const changeClient = async (item) => {
    data.loadingClient = true
    let index = data.clientNames.indexOf(item)
    let clientId = data.clientsClientCard[index].id
    if (data.claims === false) {
      window.postMessage({ navigate: '#/client/' + clientId })
    } else {
      await ApiWrapper.post('client-card', 'change-client', {
            clientId: clientId,
            claimId: props.contextIdA,
          })
          .then((response) => {
            activeComponentStore.notifyComponents(['clients'],compName);
            getData()
            ToastUtil.successMsg('Updated client contact');
          })
          .catch((e)=>{
            ToastUtil.error(e);
            data.loadingClient = false;
          })
    }
  }
  
  onMounted(()=>{
    data.contextSchema = props.contextSchemaA;

    getData()
    getClientContactData()
  });
  
</script>

<template>
  <v-container fluid class="pt-5">
      <v-card class="elevation-2 pa-5" height="auto" width="auto" >
        <v-container v-if="data.loadingClient">
          <v-row
              class="fill-height"
              align-content="center"
              justify="center"
          >
            <v-col class="subtitle-1 text-center" cols="6">
              Loading Client...
            </v-col>
            <v-col cols="6" class="text-center">
              <v-progress-circular
                  :size="70"
                  :width="7"
                  color="primary"
                  indeterminate
              ></v-progress-circular>
            </v-col>
          </v-row>
        </v-container>

        <div v-if="!data.changingClient && !data.loadingClient && data.name !== undefined">
          <v-row class="px-7">
            <h2>{{data.name}}</h2>
          </v-row>

          <v-row class="px-4">
            <v-col cols="12" class="py-0">
              <v-list-item-title id="client__message"
              >Client Message</v-list-item-title
              >
              <v-list-item style="overflow: auto !important;">
                <p>
                  {{data.clientmessage}}
                </p>
              </v-list-item>

            </v-col>
          </v-row>
        </div>

        <div v-if="!data.loadingClient && data.name === undefined">
          <v-row
              density="compact"
              class="fill-height"
              align-content="center"
              justify="center"
          >
            <v-col class="subtitle-1 text-center" cols="12">
              No Client Selected
            </v-col>
          </v-row>
        </div>

        <v-row v-if="data.changingClient && !data.loadingClient">
          <v-col cols="12">
            <v-text-field
                class="mx-4"
                type="text"
                v-model="data.search"
                label="Search Clients"
                prepend-inner-icon=" mdi-magnify"
            >
            </v-text-field>
            <v-list-subheader>Select Client</v-list-subheader>
            <v-divider></v-divider>
            <v-list class="v_list_search">
              <v-list-item v-for="(item, i) in filteredItems" :key="i" class="v-list-item--link" v-ripple>
                <v-list-item-title
                    @click="changeClient(item)"
                >{{item}}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
        <v-divider v-if="data.changingClient && data.loadingClient === false"></v-divider>
        <v-card-actions>
          <v-btn
              size="small"
              variant="elevated"
              v-if="!data.changingClient && Permissions.checkPermissions(['claims.change-client']) && data.clientId === null"
              dark
              color="primary"
              @click="data.changingClient=true"
          >Add Client</v-btn
          >
          <v-btn
              size="small"
              variant="elevated"
              v-if="!data.changingClient && Permissions.checkPermissions(['claims.change-client']) && data.clientId !== null"
              dark
              color="primary"
              @click="data.changingClient=true"
          >Change Client</v-btn
          >
          <v-spacer v-if="!data.changingClient"></v-spacer>
          <v-btn size="small" variant="elevated" v-if="!data.changingClient && data.contextSchema === 'claims' && Permissions.checkPermissions(['clients.read']) && data.clientId !== null">
              <RouterLink :to="`/client/${data.clientId}`">View Client</RouterLink>
          </v-btn>

          <v-btn
              size="small"
              variant="elevated"
              v-if="data.changingClient && data.loadingClient === false"
              color="error"
              dark
              @click="data.changingClient=false"
          >
            Cancel
          </v-btn>
        </v-card-actions>

        <v-toolbar min-height density="compact" flat color="white">
          <v-toolbar-title class="toolbar__title__color">File Uploads</v-toolbar-title>
        </v-toolbar>
        <v-list flat>
          <template v-for="(file, index) in data.files" :key="file.id">
            <v-list-item class="v-list-item--link ma-2" v-ripple>
              <template v-slot:default="{}">
                <div class="files-container-columns v-list-font">
                  <div @click="windowOpen(file)" class="flex-grow word-wrap-break">
                    <span v-if="(file.uploadedBy !== '' && file.uploadedBy !== undefined && file.uploadedBy !== null)&& !file.metadata.displayName">
                      {{file.filename}} - Uploaded by {{file.uploadedby}}
                    </span>
                    <span v-else-if="(file.uploadedBy !== '' && file.uploadedBy !== undefined && file.uploadedBy !== null )&& file.metadata.displayName">
                      {{file.filename}} - Uploaded by {{file.uploadedby}}
                    </span>
                    <span v-else-if="file.metadata.displayName">
                      {{file.metadata.displayName}}
                    </span>
                    <span v-else>
                      {{file.filename}}
                    </span>
                  </div>
                  <div class="flex-shrink">
                    <v-icon>mdi-download</v-icon>
                  </div>
                </div>
              </template>
            </v-list-item>
            <v-divider
                v-if="index + 1 < data.files.length"
                :key="index"
            ></v-divider>
          </template>
        </v-list>

        <v-divider></v-divider>

        <v-toolbar min-height density="compact" flat color="white">
          <v-toolbar-title class="toolbar__title__color">Client Contacts</v-toolbar-title>
          <v-progress-linear
              :active="data.loading"
              :indeterminate="data.loading"
              absolute
              bottom
              color="primary"
          >
          </v-progress-linear>
          <v-btn
              class="ml-2"
              dark
              size="x-small"
              variant="elevated"
              color="primary"
              @click="data.addContact = true; data.newItem = Object.assign({}, data.resetContactItem)"
              v-if="data.clientSelected === true && !data.addContact"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>

        <!-- If there is no client selected for the current claim -->
        <v-card-subtitle v-if="data.clientSelected === false">
          There is no client assigned to this claim. Please select a client
          in order to add contacts.
        </v-card-subtitle>
        <div v-if="data.clientSelected === true">
          <!-- Search Client Contacts -->
          <v-form
              v-if="data.addContact === true && data.openForm === false"
              ref="form"
              v-model="data.valid"
              lazy-validation
          >
            <v-autocomplete
                class="px-4"
                v-model="data.searchedContact"
                :items="data.clients"
                label="Enter or Select Client Contact"
                clearable
                item-title="text"
            >
            </v-autocomplete>
            <v-card-actions v-if="data.searchedContact">
              <v-btn
                  v-if="data.searchedContact && data.loading === false && Permissions.checkPermissions(['claims.link-contact'])"
                  size="x-small"
                  variant="elevated"
                  color="success"
                  class="white--text"
                  :disabled="!data.valid"
                  @click="selectContact(); data.addContact = false"
              >
                Add Selection</v-btn
              >
              <v-btn
                  v-if="data.searchedContact && data.loading === true"
                  size="x-small"
                  variant="elevated"
                  color="success"
                  class="white--text"
                  disabled
              >
                Add Selection</v-btn
              >
            </v-card-actions>
          </v-form>
          <v-card-actions v-if="data.addContact === true && data.openForm === false">
            <v-btn dark size="x-small" variant="elevated" color="error" @click="data.addContact = false"
            >Cancel
            </v-btn>
          </v-card-actions>

          <v-card-actions v-if="data.addContact === true && !data.openForm">
            <v-btn dark size="x-small" variant="elevated" color="primary" @click="data.openForm = true" v-if="Permissions.checkPermissions(['claims.create-contact'])"
            >Create New Contact
            </v-btn>
          </v-card-actions>

          <!-- Contact Info -->
          <v-form
              v-if="data.openForm"
              ref="form"
              v-model="data.valid"
              lazy-validation
          >
            <v-autocomplete
                class="px-5 pt-4"
                density="compact"
                v-model="data.newItem.role"
                :items="data.role"
                label="Enter or Select Type of Contact"
                clearable
                required
            >
            </v-autocomplete>
            <v-card-subtitle class="pt-0" v-if="data.newItem.role"
            >{{data.newItem.role}}</v-card-subtitle
            >
            <v-text-field
                density="compact"
                v-model="data.newItem.insuredname"
                label="Name"
                class="px-5"
                :rules="[v => !!v || 'Name is required']"
                required
            >
            </v-text-field>
            <v-text-field
                density="compact"
                v-model="data.newItem.streetaddress"
                label="Street Address"
                class="px-5"
                required
            ></v-text-field>
            <v-text-field
                density="compact"
                v-model="data.newItem.city"
                label="City"
                class="px-5"
                required
            >
            </v-text-field>
            <v-text-field
                density="compact"
                v-model="data.newItem.state"
                label="State"
                class="px-5"
                required
            >
            </v-text-field>
            <v-text-field
                density="compact"
                v-model="data.newItem.zip"
                label="Zip"
                class="px-5"
                required
            >
            </v-text-field>
            <v-text-field
                density="compact"
                v-model="data.newItem.homephone"
                @input="acceptNumber"
                :rules="[FormValidation.phoneRules]"
                label="Phone"
                class="px-5"
                required
            ></v-text-field>
            <v-text-field
                density="compact"
                v-model="data.newItem.email"
                label="Email"
                class="px-5"
                required
            >
            </v-text-field>
            <v-card-actions>
              <v-btn
                  size="small"
                  variant="elevated"
                  v-if="data.openForm"
                  color="red"
                  class="white--text mr-2"
                  @click="cancel(); data.addContact = false"
              >Cancel</v-btn
              >
              <v-btn
                  size="small"
                  variant="elevated"
                  v-if="data.loading===true"
                  color="primary"
                  class="white--text"
                  disabled
              >Submit
              </v-btn>
              <v-btn
                  size="small"
                  variant="elevated"
                  v-else
                  color="primary"
                  class="white--text"
                  @click="create(); data.addContact = false"
                  :disabled="!data.valid"
              >Submit
              </v-btn>
            </v-card-actions>
          </v-form>

          <!-- List of contacts if there are more than 1 contact -->
          <v-list
              density="compact"
              v-if="data.items.length >= 1 && !data.openForm && !data.contactSelected && !data.addContact"
              class="py-0"
          >
            <v-list-item
                density="compact"
                two-line
                v-for="(item) in data.items"
                :key="item.index"
                @click="chooseContact(item); data.contactSelected = true"
            >

                <v-list-item-subtitle>{{item.role}}</v-list-item-subtitle>
                <v-list-item-title
                >{{item.insuredname}}</v-list-item-title
                >
            </v-list-item>
          </v-list>

          <!-- Selected Contact -->
          <div v-if="typeof data.selected === 'object' && !data.openForm && data.contactSelected === true">
            <v-list density="compact" two-line v-for="(item, index) in data.selected" :key="index">
              <v-card-subtitle class="py-0 font-weight-bold">{{item.role}}</v-card-subtitle>
              <div class="pl-4 py-1">
                <v-list-item-subtitle>Name</v-list-item-subtitle>
                <v-list-item-title>{{item.insuredname}}</v-list-item-title>
              </div>
              <div v-if="item.streetaddress !== null && item.streetaddress !== ''" class="pl-4 py-1">
                <v-list-item-subtitle>Address</v-list-item-subtitle>
                <v-list-item-title
                >{{item.streetaddress}}
                  <br />
                  {{item.city}} {{item.state}} {{item.zip}}
                </v-list-item-title>
              </div>
              <div
                  v-if="item.homephone !== null && item.homephone !== ''"
                  :class="{'phone-hover': data.hovered}"
                  class="pl-4 py-1"
                  style="cursor:pointer"
                  @mouseover="data.hovered = true"
                  @mouseleave="data.hovered = false"
                  @click="Permissions.checkPermissions(['relationship-management.create']) ? data.phoneMessage = true : true">
                <v-list-item-subtitle>Home Phone</v-list-item-subtitle>
                <v-list-item-title>{{formatPhoneNumber(item.homephone)}}</v-list-item-title>
              </div>
              <div v-if="data.phoneMessage === true">
                <v-textarea
                    density="compact"
                    filled
                    v-model="data.phoneMessageDetails"
                    auto-grow
                    rows="2"
                    label="Phone Message Details"
                >
                </v-textarea>
                <v-btn
                    @click="saveMessage('phone', item.id)"
                    color="primary"
                    v-if="data.phoneMessageDetails !== ''"
                    size="small"
                    variant="elevated"
                >Save</v-btn
                >
                <v-btn
                    size="small"
                    variant="elevated"
                    @click="data.phoneMessage = false; data.phoneMessageDetails = ''"
                >Cancel</v-btn
                >
                <v-divider></v-divider>
              </div>
              <div
                  v-if="item.email !== null && item.email !== ''"
                  :class="{'email-hover': data.hovered2}"
                  class="pl-4 py-1"
                  style="cursor:pointer"
                  @mouseover="data.hovered2 = true"
                  @mouseleave="data.hovered2 = false"
                  @click="Permissions.checkPermissions(['relationship-management.create']) ? data.emailMessage = true : true"
              >
                <v-list-item-subtitle>Email</v-list-item-subtitle>
                <v-list-item-title>{{item.email}}</v-list-item-title>
              </div>
              <div style="margin: 10px" v-if="data.emailMessage === true">
                <v-textarea
                    density="compact"
                    filled
                    v-model="data.emailMessageDetails"
                    auto-grow
                    rows="2"
                    label="Email Message Details"
                >
                </v-textarea>
                <v-btn
                    @click="saveMessage('email', item.id)"
                    color="primary"
                    v-if="data.emailMessageDetails !== ''"
                    size="small"
                    variant="elevated"
                >Save</v-btn
                >
                <v-btn
                    size="small"
                    variant="elevated"
                    @click="data.emailMessage = false; data.emailMessageDetails = ''"
                >Cancel</v-btn
                >
                <v-divider></v-divider>
              </div>
            </v-list>
            <v-card-actions>
              <v-btn size="small" variant="text" class="primary--text mr-1" @click="back">
                <v-icon>mdi-arrow-left</v-icon>
                Back
              </v-btn>
              <v-btn size="small" variant="elevated" v-if="data.edit && Permissions.checkPermissions(['claims.update-contact'])" class="mr-2" color="primary" @click="editSelectedItem()"
              >Edit
              </v-btn>
              <v-dialog
                  v-model="data.dialog"
                  persistent
                  max-width="290"
              >
                <template v-slot:activator="{ on, props }">
                  <v-btn
                      size="small"
                      variant="elevated"
                      color="error"
                      class="mr-0"
                      dark
                      v-bind="props"
                      v-on="on"
                      v-if="Permissions.checkPermissions(['claims.remove-contact'])"
                  >
                    Remove
                    <br>
                    Contact
                  </v-btn>
                </template>
                <v-card>
                  <v-card-text class="pt-2">Are you sure you would like to remove the selected contact?</v-card-text>
                  <v-card-actions>

                    <v-btn
                        size="small"
                        color="error"
                        variant="text"
                        @click="dialog = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                        size="small"
                        color="green darken-1"
                        variant="text"
                        @click="removePerson(data.selected[0].id)"
                    >
                      Confirm
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-actions>
          </div>
        </div>
      </v-card>
  </v-container>
</template>

<style scoped>
  .container {
    padding: 5px;
  }
  [v-cloak] {
    display: none;
  }
  .v_list_search {
    height: 200px;
    overflow-y: auto;
  }
  .v-list-item-subtitle {
    color: black !important;
    font-size: 10px !important;
  }
  .v-list-item-title {
    color: black !important;
    font-size: 13px !important;
  }
  .v-card-subtitle {
    color: black !important;
  }
  
  p {
    font-size: 12px !important;
    font-family: sans-serif;
  }
  #client__message {
    padding-top: 8px !important;
  }

  .v-list-item {
    min-height: 40px !important;
  }
  .phone-hover {
    background-color: #E3F2FD;
  }
  .email-hover {
    background-color: #E3F2FD;
  }
  .toolbar__title__color {
    color: #1976D2;
    font-size: 1rem !important;
  }
</style>